var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapLocationMarkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2608241"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 97",
    opacity: 0.2,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#229986"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    opacity: 0.5,
    cx: 24,
    cy: 24,
    r: 18,
    fill: "#229986"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    cx: 24,
    cy: 24,
    r: 11,
    fill: "#229986"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocationMarkerIcon);
export default __webpack_public_path__ + "static/media/Map_location_marker_icon.5e9ea3536414e4da4f75584c06972782.svg";
export { ForwardRef as ReactComponent };